module.exports = __webpack_public_path__ + "img/Hero.3eaeaa59.jpg";